export default function debounce<T extends (...args: any[]) => any>(callback: T, wait: number, immediate = false): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null

  return function debounced(this: any, ...args: Parameters<T>) {
    const callNow = immediate && !timeout
    const next = () => callback.apply(this, args)

    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(next, wait)

    if (callNow) {
      next()
    }
  }
}
